import type { ReactElement, ReactNode } from 'react';

import Section from './Section';
import StickyButton from './StickyButton';

import type { I18nService } from '@shared/types/i18n';

import { withHashRoutePortal } from '@shared/ui/common/HashRoute';
import FullScreenWrapper from '@shared/ui/components/FullScreenWrapper';
import { withI18n } from '@shared/ui/contexts/i18n';

const FullScreenRoute = withHashRoutePortal(FullScreenWrapper);

type Props = {
  i18n: I18nService;
  children: ReactNode;
  viewportMoreContent: ReactElement;
  href: string;
  showActionLink?: boolean;
  title?: string;
  headline?: string;
  actionLinkClassName?: string;
  actionLabel?: string;
  contentClassName?: string;
  headerClassName?: string;
};
const ExpandableSection = ({
  actionLabel,
  actionLinkClassName,
  children,
  contentClassName,
  headerClassName,
  headline,
  href,
  i18n,
  showActionLink = false,
  title,
  viewportMoreContent,
}: Props) => (
  <>
    <Section
      actionLabel={
        actionLabel || i18n.translate('Viewed_hotels_viewAll_btn_text')
      }
      actionLinkClassName={actionLinkClassName}
      showActionLink={showActionLink}
      href={href}
    >
      {children}
    </Section>

    <FullScreenRoute
      title={title}
      headline={headline}
      contentClassName={contentClassName}
      hash={href}
      headerClassName={headerClassName}
      renderFooter={(onClose: () => void) => (
        <StickyButton onClick={onClose} isSubPage />
      )}
    >
      {viewportMoreContent}
    </FullScreenRoute>
  </>
);

export default withI18n(ExpandableSection);
